import { CommonModule } from '@angular/common';
import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewEncapsulation } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

import { Star } from '@app/shared/models';
import { StarType } from '@app/shared/types';
import { TranslateModule } from '@ngx-translate/core';
import {MatTooltipModule} from '@angular/material/tooltip';

@Component({
    selector: 'tc-star-rating',
    imports: [
        MatIconModule,
        TranslateModule,
        CommonModule,
        MatTooltipModule
    ],
    templateUrl: './star-rating.component.html',
    styleUrls: ['./star-rating.component.scss']
})
export class StarRatingComponent implements OnInit, OnChanges {

  @Output() rateEmit = new EventEmitter<number>();
  @Input() count: number;
  @Input() value: number;

  starList: Star[];
  hoveredStarList: Star[];
  stableValue: number;
  starType = StarType;

  // boolean
  previusClickSideIsHalf: boolean;

  constructor() { }

  ngOnChanges(): void {
    this.setup();
  }

  ngOnInit() {
    this.setup();
  }

  setup(): void {
    this.starList = [];
    this.stableValue = this.value;
    for (let i = 0; i < this.count; i++) {
      if (this.value > i) {
        if (this.value < (i + 1)) {
          this.starList.push({ starType: StarType.Half });

        } else {
          this.starList.push({ starType: StarType.Full });

        }

      } else {
        this.starList.push({ starType: StarType.Empty });
      }

    }
  }

  selectNewRate(index: number, star): void {
    if (this.stableValue > 0) {
      return;
    }
    index = this.clickedOnHalf(star) ? (index + .5) : (index + 1);
    this.rateEmit.emit(index);

  }

  calcNewRate(index: number): void {
    for (let i = 0; i < this.count; i++) {
      if (index > i) {
        if (index < (i + 1)) {
          this.starList[i].starType = StarType.Half;
        } else {
          this.starList[i].starType = StarType.Full;

        }

      } else {
        this.starList[i].starType = StarType.Empty;
      }
    }
  }

  mouseEnter(index: number, event): void {
    if (this.stableValue > 0) {
      return;
    }
    this.previusClickSideIsHalf = this.clickedOnHalf(event);
    index = this.previusClickSideIsHalf ? (index + .5) : (index + 1);
    this.calcNewRate(index);
  }

  mouseMove(index: number, event): void {
    if (this.clickedOnHalf(event) === this.previusClickSideIsHalf) {
      return;
    }
    this.mouseEnter(index, event);
  }

  mouseLeave(): void {
    if (this.stableValue > 0) {
      return;
    }
    this.calcNewRate(this.stableValue);
  }

  private clickedOnHalf(event): boolean {
    const half = event.currentTarget.offsetWidth / 2;
    const clickedX = event.clientX - event.currentTarget.offsetLeft;
    if (clickedX < half) {
      return true;
    } else {
      return false;
    }
  }

}
